import {
  ColorOakSwatchMap,
  Model,
  TopColorCeramicSwatchMap,
  TopColorFenixSwatchMap,
  attachComponent,
} from 'algu-domain'
import { match } from 'ts-pattern'

import { materialSwatchComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain'

export const topComponents = [
  attachComponent
    .withComponent(materialSwatchComponent, 'topColor')
    .withAlias('Top')
    .attach(
      memoEval(
        self => {
          /**
           * Available colors for round table tops depend on the diameter so we need to
           * account for this in the memoization and it can not be auto-generated.
           */
          const diameter = Model.TopCircle.is(self) ? self.diameter : undefined
          const topColorSwatches = match(self.material)
            .with(Model.TopMaterial.Fenix, () => TopColorFenixSwatchMap)
            .with(Model.TopMaterial.SolidOak, () => ColorOakSwatchMap)
            .with(Model.TopMaterial.Ceramic, () => TopColorCeramicSwatchMap)
            .exhaustive()

          return [self.color, topColorSwatches, diameter]
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (color, topColorSwatches, _diameter) => ({
          title: 'NOT USED',
          selectedSwatchKey: color,
          swatches: topColorSwatches,
        })
      ),
      state => {
        Model.TopColor.assert(state.selectedSwatchKey)
        return { color: state.selectedSwatchKey }
      }
    ),
]
